<template>
  <div class="product-header pl-4 pr-4 pt-2 pb-2 mb-3">
    <h3 class="m-0 h4">
      <slot name="icon"> </slot>
      <strong><slot name="title"></slot></strong>
      <span v-if="hasTooltipSlot" class="ml-1">
        <b-button id="late-fee-info" class="tooltip-btn" title="fees info">
          <fa-icon size="sm" :icon="['fas', 'info-circle']" class="tooltip-info" />
        </b-button>
        <b-tooltip target="late-fee-info" triggers="hover click blur" placement="right">
          <slot name="tooltip"></slot>
        </b-tooltip>
      </span>
    </h3>
  </div>
</template>

<script>
export default {
  computed: {
    hasTooltipSlot() {
      return Boolean(this.$slots.tooltip);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
div.product-header {
  background-color: $dp-light-blue;
  text-transform: uppercase;
  .icon {
    margin-top: -0.18rem;
  }
}
</style>
